import { Value } from 'components/forms/types';
import { DropdownItem } from 'components/generic-question/Dropdown';

const getSelected = (items: DropdownItem[]): Value =>
  items?.filter(e => e?.isSelected)?.[0]?.value;

export { getSelected };
